<template>
  <div class="alignment">
    <!--inserimento articolo-->
    <v-flex xs12 sm6 class="styleAlignementInsertItem">
      <h3 class="styleHeader">
        {{ $t("pages.Item.Create.InserimentoArticolo") }}
      </h3>
      <v-card class="styleDataTable">
        <customerComponent
          v-on:customerChange="custChanged"
          ref="customerComponent"
        ></customerComponent>
      </v-card>
    </v-flex>

    <!--dati nuovo articolo-->
    <v-flex xs12 sm6 class="styleHeaderTop styleAlignementInsertItem">
      <h4 class="styleHeader styleButtonTop">
        {{ $t("pages.Item.Create.NuovoCodiceArticolo") }}
      </h4>
      <v-card class="styleDataTable">
        <template>
          <v-form ref="form">
            <v-container grid-list-md text-xs-center style="padding: 0px">
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                    v-model="itemCode"
                    :label="$t('pages.Item.Create.CodiceArticolo')"
                    required
                    :error-messages="itemCodeErrors"
                    @input="$v.itemCode.$touch()"
                    @blur="$v.itemCode.$touch()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="secondaryitemCode"
                    :label="$t('pages.Item.Create.CodiceArticoloSecondario')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                    v-model="description"
                    :label="$t('pages.Item.Create.LabelDescrizione')"
                    required
                    :error-messages="descriptionErrors"
                    @input="$v.description.$touch()"
                    @blur="$v.description.$touch()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="secondaryDescription"
                    :label="$t('pages.Item.Create.LabelDescrizioneSec')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6 class="text-xs-left title">
                  <h4>{{ $t("pages.Item.Create.DatiFisici") }}</h4>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                    v-model="measureUnit"
                    :label="$t('pages.Item.Create.LabelUnitaMisura')"
                    required
                    :error-messages="measureUnitErrors"
                    @input="$v.measureUnit.$touch()"
                    @blur="$v.measureUnit.$touch()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="grossWeight"
                    :label="$t('pages.Item.Create.LabelPesoLordo')"
                    :rules="[rules.decimal]"
                    required
                    :error-messages="grossWeightErrors"
                    @input="$v.grossWeight.$touch()"
                    @blur="$v.grossWeight.$touch()"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                    v-model="qtaInner"
                    :label="$t('pages.Item.Create.LabelQtaInner')"
                    type="number"
                    :rules="[rules.digits]"
                    required
                    :error-messages="qtaInnerErrors"
                    @input="$v.qtaInner.$touch()"
                    @blur="$v.qtaInner.$touch()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="netWeight"
                    :label="$t('pages.Item.Create.LabelPesoNetto')"
                    :rules="[rules.decimal]"
                    required
                    :error-messages="netWeightErrors"
                    @input="$v.netWeight.$touch()"
                    @blur="$v.netWeight.$touch()"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                    v-model="qtaMaster"
                    :label="$t('pages.Item.Create.LabelQtaMaster')"
                    type="number"
                    :rules="[rules.digits]"
                    required
                    :error-messages="qtaMasterErrors"
                    @input="$v.qtaMaster.$touch()"
                    @blur="$v.qtaMaster.$touch()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-text-field
                    v-model="width"
                    :label="$t('pages.Item.Create.LabelLarghezza')"
                    :rules="[rules.decimal]"
                    required
                    :error-messages="widthErrors"
                    @input="$v.width.$touch()"
                    @blur="$v.width.$touch()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-text-field
                    v-model="height"
                    :label="$t('pages.Item.Create.LabelAltezza')"
                    :rules="[rules.decimal]"
                    required
                    :error-messages="heightErrors"
                    @input="$v.height.$touch()"
                    @blur="$v.height.$touch()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-text-field
                    v-model="depth"
                    :label="$t('pages.Item.Create.LabelProfondità')"
                    :rules="[rules.decimal]"
                    required
                    :error-messages="depthErrors"
                    @input="$v.depth.$touch()"
                    @blur="$v.depth.$touch()"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                    v-model="qtaPackage"
                    :label="$t('pages.Item.Create.LabelQtaPerConfezione')"
                    type="number"
                    :rules="[rules.digits]"
                    required
                    :error-messages="qtaPackageErrors"
                    @input="$v.qtaPackage.$touch()"
                    @blur="$v.qtaPackage.$touch()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="volume"
                    :label="$t('pages.Item.Create.LabelVolume')"
                    :rules="[rules.decimal]"
                    required
                    :error-messages="volumeErrors"
                    @input="$v.volume.$touch()"
                    @blur="$v.volume.$touch()"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                    v-model="qtaPallet"
                    :label="$t('pages.Item.Create.LabelQtaPallet')"
                    type="number"
                    :rules="[rules.digits]"
                    required
                    :error-messages="qtaPalletErrors"
                    @input="$v.qtaPallet.$touch()"
                    @blur="$v.qtaPallet.$touch()"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </template>
      </v-card>
    </v-flex>

    <!--dati nuova tabella barcodes-->
    <v-layout>
      <v-flex xs12 sm6 class="styleAlignementInsertItem">
        <div>
          <v-toolbar
            flat
            style="background-color:#fafafa; margin-top: 10px; margin-left:-24px; height=82px;"
          >
            <h4 class="styleHeader styleHeaderTop pa-0">
              {{ $t("pages.Item.Create.Barcodes") }}:
            </h4>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="80%">
              <template v-slot:activator="{ on }">
                <v-btn
                  color="#279947"
                  class="right white--text styleHeader styleAlignamentAddButton"
                  style="margin-right:-48px;"
                  v-on="on"
                >
                  <v-icon left>add</v-icon>
                  {{ $t("pages.Item.Create.Aggiungi") }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline" style="padding-left: 0px">
                    {{ formTitle }}
                  </span>
                </v-card-title>

                <v-card-text style="padding -16px">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs6>
                        <v-text-field
                          v-model="barcode"
                          :label="$t('pages.Item.Create.Barcodes')"
                          required
                          :error-messages="barcodeError"
                          @input="$v.barcode.$touch()"
                          @blur="$v.barcode.$touch()"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          v-model="qta"
                          :label="$t('pages.Item.Create.LabelQtaPezzi')"
                          type="number"
                          :rules="[rules.digits]"
                          required
                          :error-messages="qtaError"
                          @input="$v.qta.$touch()"
                          @blur="$v.qta.$touch()"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="save()"
                    class="white--text styleButtonTop"
                    style="margin-left: 0px; margin-right: 16px;"
                    color="#279947"
                  >
                    <v-icon left>check_circle</v-icon>
                    {{ $t("pages.Item.Create.Salva") }}:
                  </v-btn>
                  <v-btn
                    class="styleButtonTop"
                    style="margin-left: 0px"
                    @click="close()"
                  >
                    <v-icon left>remove_circle</v-icon>
                    {{ $t("pages.Item.Create.Annulla") }}:
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>

          <v-data-table
            style="border-top: 10px"
            :headers="getHeaders"
            :items="barcodes"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.barcode }}</td>
              <td>{{ props.item.qta }}</td>
              <td class="justify-center layout px-0">
                <v-icon small class="mr-2" @click="editItem(props.item)"
                  >edit</v-icon
                >
                <v-icon small @click="deleteItem(props.item)">delete</v-icon>
              </td>
            </template>
            <!-- <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>-->
          </v-data-table>
        </div>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12>
        <v-btn
          @click="openSaveDialog()"
          class="white--text styleButtonTop"
          style="margin-left: 0px"
          color="#279947"
        >
          <v-icon left>check_circle</v-icon>
          {{ $t("pages.Item.Create.AddArticolo") }}:
        </v-btn>
        <v-btn class="styleButtonTop" style="margin-left: 0px" @click="back()">
          <v-icon left>remove_circle</v-icon>
          {{ $t("pages.Item.Create.Annulla") }}:
        </v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="insertDialog" persistent max-width="400">
      <template v-slot:activator="{ on }"></template>
      <v-card>
        <v-card-title class="headline">Inserimento Articolo</v-card-title>
        <v-card-text
          >{{ $t("pages.Item.Create.AddArticoloDesc") }}:</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="
              insertDialog = false;
              submit();
            "
            class="white--text"
            style="margin-left: 0px; margin-right: 16px;"
            color="#279947"
          >
            <v-icon left>check_circle</v-icon>Ok
          </v-btn>

          <v-btn
            class="styleButtonTop"
            style="margin-left: 0px"
            @click="insertDialog = false"
          >
            <v-icon left>remove_circle</v-icon>
            {{ $t("pages.Item.Create.Annulla") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-alert :value="errorAlert" type="error" transition="scale-transition">{{
      errorMessage
    }}</v-alert>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import stocksApi from "../../apiSmartLogistics/stocksApi.js";
import operationsApi from "../../apiSmartLogistics/operationsApi.js";
import router from "@/router/index.js";
import customerComponent from "../../Components/CustomersComponent.vue";

import { Trans } from "@/plugins/Translation";

export default {
  mixins: [validationMixin],
  validations: {
    itemCode: { required },
    description: { required },
    measureUnit: { required },
    grossWeight: { required },
    qtaInner: { required },
    netWeight: { required },
    qtaMaster: { required },
    depth: { required },
    width: { required },
    height: { required },
    qtaPackage: { required },
    volume: { required },
    qtaPallet: { required },
    qta: { required },
    barcode: { required }
  },
  components: { customerComponent },
  data: () => ({
    dialog: false,
    insertDialog: false,
    dataTables: [],
    editedIndex: -1,
    barcodes: [],
    errorAlert: false,
    errorMessage: "",
    mask: "####,###",
    customerSelected: "",
    editedItem: { barcode: "", qta: "" },
    defaultItem: { barcode: "", qta: "" },

    rules: {
      required: value =>
        !!value || this.currentLanguage.t("pages.Item.Create.NonVuoto"),
      counter: value =>
        value.length <= 20 ||
        this.currentLanguage.t("pages.Item.Create.Massimo20"),
      digits: value => {
        const pattern = /^[0-9]*$/;
        return (
          pattern.test(value) ||
          this.currentLanguage.t("pages.Item.Create.Digits")
        );
      },
      decimal: value => {
        const pattern = /^(\d{1,4}|\d{1,4},\d{1,3})$/;
        return (
          pattern.test(value) ||
          this.currentLanguage.t("pages.Item.Create.FormatoRichiesto")
        );
      }
    },
    //barcodes:
    barcode: "",
    qta: "",
    itemCode: "",
    secondaryitemCode: "",
    description: "",
    secondaryDescription: "",
    measureUnit: "PZ",
    grossWeight: "0,000",
    qtaInner: 0,
    netWeight: "0,000",
    qtaMaster: 0,
    width: "0,000",
    height: "0,000",
    depth: "0,000",
    qtaPackage: 0,
    volume: "0,000",
    qtaPallet: 0
  }),

  computed: {

    getHeaders(){
      var headers = [
      {
        text: this.currentLanguage.t("pages.Item.Create.Barcodes"),
        align: "left",
        sortable: false,
        value: "barcode"
      },
      {
        text: this.currentLanguage.t("pages.Item.Create.LabelQtaPezzi"),
        value: "qta",
        align: "left",
        sortable: false
      },
      { text: "", sortable: false }
    ]
    return headers;
    },
    currentLanguage() {
      return Trans.i18n;
    },
    formTitle() {
      //return this.editedIndex === -1 ? 'Nuovo articolo' : 'Modifica articolo'
      if (this.editedIndex === -1) {
        this.clearEditItem();
        return this.currentLanguage.t("pages.Item.Create.Nuovo");
      } else {
        return this.currentLanguage.t("pages.Item.Create.Modifica");
      }
    },

    itemCodeErrors() {
      const errors = [];
      if (!this.$v.itemCode.$dirty) return errors;
      !this.$v.itemCode.required &&
        errors.push(
          this.currentLanguage.t("Validations.InserireCodiceArticolo")
        );
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.description.$dirty) return errors;
      !this.$v.description.required &&
        errors.push(
          this.currentLanguage.t("Validations.InserireDescrizioneArticolo")
        );
      return errors;
    },
    measureUnitErrors() {
      const errors = [];
      if (!this.$v.measureUnit.$dirty) return errors;
      !this.$v.measureUnit.required &&
        errors.push(this.currentLanguage.t("Validations.InserireUnitaMisura"));
      return errors;
    },
    grossWeightErrors() {
      const errors = [];
      if (!this.$v.grossWeight.$dirty) return errors;
      !this.$v.grossWeight.required &&
        errors.push(this.currentLanguage.t("Validations.RequiredInsert0"));
      return errors;
    },
    qtaInnerErrors() {
      const errors = [];
      if (!this.$v.qtaInner.$dirty) return errors;
      !this.$v.qtaInner.required &&
        errors.push(this.currentLanguage.t("Validations.RequiredInsert0"));
      return errors;
    },
    netWeightErrors() {
      const errors = [];
      if (!this.$v.netWeight.$dirty) return errors;
      !this.$v.netWeight.required &&
        errors.push(this.currentLanguage.t("Validations.RequiredInsert0"));
      return errors;
    },
    qtaMasterErrors() {
      const errors = [];
      if (!this.$v.qtaMaster.$dirty) return errors;
      !this.$v.qtaMaster.required &&
        errors.push(this.currentLanguage.t("Validations.RequiredInsert0"));
      return errors;
    },
    widthErrors() {
      const errors = [];
      if (!this.$v.width.$dirty) return errors;
      !this.$v.width.required &&
        errors.push(this.currentLanguage.t("Validations.RequiredInsert0"));
      return errors;
    },
    heightErrors() {
      const errors = [];
      if (!this.$v.height.$dirty) return errors;
      !this.$v.height.required &&
        errors.push(this.currentLanguage.t("Validations.RequiredInsert0"));
      return errors;
    },
    depthErrors() {
      const errors = [];
      if (!this.$v.depth.$dirty) return errors;
      !this.$v.depth.required &&
        errors.push(this.currentLanguage.t("Validations.RequiredInsert0"));
      return errors;
    },
    qtaPackageErrors() {
      const errors = [];
      if (!this.$v.qtaPackage.$dirty) return errors;
      !this.$v.qtaPackage.required &&
        errors.push(this.currentLanguage.t("Validations.RequiredInsert0"));
      return errors;
    },
    volumeErrors() {
      const errors = [];
      if (!this.$v.volume.$dirty) return errors;
      !this.$v.volume.required &&
        errors.push(this.currentLanguage.t("Validations.RequiredInsert0"));
      return errors;
    },
    qtaPalletErrors() {
      const errors = [];
      if (!this.$v.qtaPallet.$dirty) return errors;
      !this.$v.qtaPallet.required &&
        errors.push(this.currentLanguage.t("Validations.RequiredInsert0"));
      return errors;
    },
    qtaError() {
      const errors = [];
      if (!this.$v.qta.$dirty) return errors;
      !this.$v.qta.required &&
        errors.push(this.currentLanguage.t("Validations.InserireQuantità"));
      return errors;
    },
    barcodeError() {
      const errors = [];
      if (!this.$v.barcode.$dirty) return errors;
      !this.$v.barcode.required &&
        errors.push(this.currentLanguage.t("Validations.InserireBarcode"));
      return errors;
    }
  },

  created() {
    const id = this.$route.params.id;

    if (id) {
      stocksApi.GetStockInternal(id).then(response => {
        this.id = response.data.id;
        this.databaseCodeSelected = response.data.databaseCode;
        this.serverName = response.data.serverName;
        this.dbName = response.data.dbName;
        this.name = response.data.name;
      });
    }

    stocksApi.GetStocks().then(response => {
      this.databaseCode = response.data;
    });
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  // created () {
  //   this.initialize()
  //   },

  methods: {
    //new table
    editItem(item) {
      this.editedIndex = this.barcodes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.qta = this.editedItem.qta;
      this.barcode = this.editedItem.barcode;
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.barcodes.indexOf(item);
      this.barcodes.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    clearEditItem() {
      this.qta = 0;
      this.barcode = " ";
    },

    save() {
      this.$v.$touch();
      if (!this.$v.qta.$error && !this.$v.barcode.$error) {
        if (this.editedIndex > -1) {
          this.editedItem = { qta: this.qta, barcode: this.barcode };
          Object.assign(this.barcodes[this.editedIndex], this.editedItem);
          this.clearEditItem();
        } else {
          this.editedItem = { qta: this.qta, barcode: this.barcode };
          this.barcodes.push(this.editedItem);
          this.clearEditItem();
        }
        this.close();
      }
    },

    custChanged(customerSelected) {
      this.customerSelected = customerSelected;
    },

    back() {
      router.push("/");
    },

    openSaveDialog() {
      this.$v.$touch();
      if (
        !this.customerSelected ||
        this.$v.itemCode.$error ||
        this.$v.description.$error ||
        this.$v.measureUnit.$error ||
        this.$v.grossWeight.$error ||
        this.$v.qtaInner.$error ||
        this.$v.netWeight.$error ||
        this.$v.qtaMaster.$error ||
        this.$v.depth.$error ||
        this.$v.width.$error ||
        this.$v.height.$error ||
        this.$v.qtaPackage.$error ||
        this.$v.volume.$error ||
        this.$v.qtaPallet.$error ||
        !this.$refs.form.validate()
      ) {
        this.$refs.customerComponent.validate();
        return;
      } else {
        this.insertDialog = true;
      }
    },
    submit() {
      let article = {
        customerId: this.customerSelected,
        barcodes: this.barcodes,
        codart: this.itemCode,
        codart2: this.secondaryitemCode,
        descr: this.description,
        descr2: this.secondaryDescription,
        umisura: this.measureUnit,
        pesolordo: this.grossWeight,
        qtainner: this.qtaInner,
        pesonetto: this.netWeight,
        qtamaster: this.qtaMaster,
        larghezza: this.width,
        altezza: this.height,
        profondita: this.depth,
        qtaconfezione: this.qtaPackage,
        volume: this.volume,
        qtapallet: this.qtaPallet
      };

      operationsApi
        .InsertArticle(article)
        .then(() => {
          router.push("/");
        })
        .catch(error => {
          this.errorAlert = true;
          this.errorMessage = error.response.data;
        });
    },
    clear() {
      this.$v.$reset();
      this.$refs.customerComponent.clear();
      this.barcodes = [{ barcode: "", qta: 0 }];
      this.itemCode = "";
      this.secondaryitemCode = "";
      this.description = "";
      this.secondaryDescription = "";
      this.measureUnit = "PZ";
      this.grossWeight = "0,000";
      this.qtaInner = 0;
      this.netWeight = "0,000";
      this.qtaMaster = 0;
      this.width = "0,000";
      this.height = "0,000";
      this.depth = "0,000";
      this.qtaPackage = 0;
      this.volume = "0,000";
      this.qtaPallet = 0;
    }
  }
};
</script>
